<swipesum-header [appName]="'CPO Portal'" homeLink="/">
	<div primary-navigation style="width: 100%;">
		<div style="display: flex; width: 100%;">
			<app-primary-nav [menu]="'primary'"></app-primary-nav>
			<div style="display: flex;gap: 30px; padding-right:24px;">
				<div style="font-size:.9em; display: flex; align-items: center;">
					<button type="button" class="help-link" (click)="onAuditClick()">audit</button>
				</div>
				<div style="font-size:.9em; display: flex; align-items: center;">
					<button type="button" class="help-link" (click)="onDocumentationClick()">documentation</button>
				</div>
				<div style="font-size:.9em; display: flex; align-items: center;">
					<button type="button" class="help-link" (click)="toggleHelp()" [attr.aria-expanded]="helpIsExpanded" aria-controls="help-container">help</button>
				</div>
				<div style="position: relative; font-size:.9em;">
					<app-profile-popup></app-profile-popup>
				</div>				
			</div>
		</div>
	</div>

</swipesum-header>

<!-- help pull down -->
<div class="help-container" id="help-container" [class.help-container--open]="helpIsExpanded">
	<div style="display: flex; width: 100%; justify-content: center; align-items: top; gap: 60px; padding: 30px 24px; ">
	<div>
		Call our support team<br/>
		<a href="tel:18448775753" class="app-footer__link">1-844-877-5753</a>
	</div>
	<div>
		Send us a message<br/>
		<a href="mailto:support@staitment.com" class="app-footer__link">support@swipesum.com</a>
	</div>
	<!-- TODO: Add link to whatever knowledge base we build-->
	<!-- <div>
		Browse the knowledge base<br/>
		[link]
	</div> -->
	<div>
		<close-x (click)="toggleHelp()" style="color: var(--green-400);"></close-x>
	</div>

	</div>
</div>


<app-impersonate-header></app-impersonate-header>

